import { useTranslation } from 'react-i18next';
import {
  CompactTable,
  Flex,
  heartbeatHelper,
  isSiemensOpcDcsPlcSubtype,
  operationalStatusHelper,
  OperationalStatusIcon,
  prmStatusHelper,
  validateOperationalStates,
} from '@mss/mss-component-library';
import React from 'react';
import { onTableChange, ROUTES } from '../../util';
import { useHistory } from 'react-router-dom';
import {
  custodianColumn,
  hostnameColumn,
  iconColumn,
  locationColumn,
  resourceColumn,
  roleColumn,
  typeColumn,
} from './columns';
import { Activity } from 'react-feather';
import { Col, Row, Tooltip } from 'antd';

const AssetMonitorCompactTable = ({ resources, loading }: any) => {
  const [t] = useTranslation(['common', 'asset']);
  const history = useHistory();
  const [assetFilters, setAssetFilters] = React.useState<string[]>([]);
  const [subTypeFilters, setSubTypeFilters] = React.useState<string[]>([]);
  const [roleFilters, setRoleFilters] = React.useState<string[]>([]);
  const [locationFilters, setLocationFilters] = React.useState<string[]>([]);
  const [custodianFilters, setCustodianFilters] = React.useState<string[]>([]);

  return (
    <CompactTable
      bordered={false}
      dataSource={resources}
      onChange={onTableChange(
        assetFilters,
        setAssetFilters,
        setSubTypeFilters,
        setRoleFilters,
        setLocationFilters,
        setCustodianFilters
      )}
      onRow={(record: any) => ({
        onClick: () => {
          history.push(ROUTES.monitors(record.data));
        },
      })}
      loading={loading}
      columns={[
        {
          title: <Activity size={18} className="mr-2 ml-2" />,
          dataIndex: '',
          key: '',
          width: 30,
          render: ({ data: record }: any) => {
            const siemensOpcNoHb =
              record?.type !== 'field' &&
              isSiemensOpcDcsPlcSubtype(record?.dcs_plc_type);
            const heartbeatApplicable =
              record?.type === 'field' || !siemensOpcNoHb;
            return (
            <Tooltip
              style={{ lineHeight: 1 }}
              placement="right"
              title={
                <div>
                  <Row>
                    <Col className="mr-1">
                      <small>
                        <b>
                          {record?.type !== 'field'
                            ? t('Operational state')
                            : t('PRM status')}
                        </b>
                        :
                      </small>
                    </Col>
                    <Col>
                      <small>
                        {record?.type !== 'field'
                          ? operationalStatusHelper(
                              record?.operational_status,
                              t
                            )
                          : prmStatusHelper(record?.asset_data.status_icon, t)}
                      </small>
                    </Col>
                  </Row>
                  {record?.type !== 'field' ? (
                    <Row>
                      <Col className="mr-1">
                        <small>
                          <b>{t('Heartbeat state')}</b>:
                        </small>
                      </Col>
                      <Col>
                        <small>
                          {siemensOpcNoHb
                            ? t('N/A')
                            : heartbeatHelper(record?.heartbeat?.state, t)}
                        </small>
                      </Col>
                    </Row>
                  ) : (
                    <></>
                  )}
                </div>
              }
            >
              <Flex h="center" v="center" className="ml-1 text-gray-500">
                <OperationalStatusIcon
                  operationalStatus={
                    record?.type !== 'field'
                      ? validateOperationalStates(record?.operational_status)
                      : 'prm'
                  }
                  heartbeatStatus={
                    record?.type !== 'field'
                      ? validateOperationalStates(record?.heartbeat?.state)
                      : record?.asset_data.status_icon
                  }
                  heartbeatApplicable={heartbeatApplicable}
                />
              </Flex>
            </Tooltip>
          );
          },
        },
        iconColumn(),
        hostnameColumn(t),
        resourceColumn(t, resources, assetFilters),
        typeColumn(
          t,
          resources.filter((x: any) => {
            if (assetFilters.length) {
              return assetFilters.includes(x.type);
            } else {
              return true;
            }
          }),
          subTypeFilters
        ),
        roleColumn(t, resources, roleFilters),
        custodianColumn(t, resources, custodianFilters),
        locationColumn(t, resources, locationFilters),
        {
          title: t('Count'),
          dataIndex: '',
          key: '',
          width: 150,
          defaultSortOrder: 'descend',
          render: (record: any) => (
            <>
              {record.count} of {record.total}
            </>
          ),
          sorter: (a: any, b: any) => a.count - b.count,
        },
      ]}
      rowKey={'id'}
    />
  );
};

export default AssetMonitorCompactTable;
